var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["./contentful-logo-asset.j2"] = require( "./contentful-logo-asset.j2" );
dependencies["./logo-asset.j2"] = require( "./logo-asset.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/logo.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/logo.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("homepageUrl")) {
var t_4 = t_1.homepageUrl;
} else {
cb(new Error("cannot import 'homepageUrl'")); return;
}
context.setVariable("homepageUrl", t_4);
if(t_1.hasOwnProperty("staticUrl")) {
var t_5 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_5);
output += "\n\n";
var t_6;
t_6 = (lineno = 2, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.logo",""]));
frame.set("hasLogoConfig", t_6, true);
if(frame.topLevel) {
context.setVariable("hasLogoConfig", t_6);
}
if(frame.topLevel) {
context.addExport("hasLogoConfig", t_6);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "setLogoToHeading")) {
output += "\n\n    <h1 class=\"c-logo\" data-qa-brand-logo>\n\n        <a ";
output += runtime.suppressValue((lineno = 8, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["top_nav","Logo"])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 8, colno = 53, runtime.callWrap(t_4, "homepageUrl", context, ["ref=logo"])), env.opts.autoescape);
output += "\" class=\"c-logo__a\" data-qa-brand-logo-link>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "hasLogoConfig")) {
output += "\n\n                ";
env.getTemplate("./contentful-logo-asset.j2", false, "core/templates/header/logo.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n            ";
})});
}
else {
output += "\n\n                ";
env.getTemplate("./logo-asset.j2", false, "core/templates/header/logo.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n            ";
})});
}
output += "\n\n        </a>\n\n    </h1>\n\n";
;
}
else {
output += "\n\n    <div class=\"c-logo\" data-qa-brand-logo>\n\n        <a ";
output += runtime.suppressValue((lineno = 28, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["top_nav","Logo"])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 28, colno = 53, runtime.callWrap(t_4, "homepageUrl", context, ["ref=logo"])), env.opts.autoescape);
output += "\" class=\"c-logo__a\" data-qa-brand-logo-link>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "hasLogoConfig")) {
output += "\n\n                ";
env.getTemplate("./contentful-logo-asset.j2", false, "core/templates/header/logo.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n            ";
})});
}
else {
output += "\n\n                ";
env.getTemplate("./logo-asset.j2", false, "core/templates/header/logo.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n            ";
})});
}
output += "\n\n        </a>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/logo.j2"] , dependencies)